var ttmap_order,
  order_markers = [];

// View: Start Order
function view_start_order() {
  var $ = jQuery;

  charleys_hide_topnav_location();
  charleys_show_loading();

  $contentContainer
    .load(templateRoot + "wf-ordering-start-order.html", function () {

      // Load map
      if ($("#tt-map").length) {
        tt.setProductInfo("Charleys Location Map", "2.0.0");
        ttmap_order = tt.map({
          key: tomtom_api_key,
          container: "tt-map",
          // style: 'tomtom://vector/1/basic-main',
          // dragPan: !isMobileOrTablet(),
          // Center on the USA
          center: [-98.5556199, 39.8097343],
          zoom: 4,
          language: "en-US",
        });
        // ttmap_order.addControl(new tt.FullscreenControl());
        // ttmap_order.addControl(new tt.NavigationControl());
      }

      // Remove reveal modal
      $('#account-select-order-type, #home-select-order-type', '#menu-select-order-type').each(function () {
        if (typeof $(this).attr('aria-hidden') !== 'undefined') {
          $(this).parent().remove();
        }
      });

      // Recreate reveal modals
      var $select_order_type_reveal = new Foundation.Reveal($('#home-select-order-type'), {});

      $('#home-select-order-type-button').click(function () {

        if ($('.data-order-type-recent-id:first').text() !== "") {
          startRecentOrder($('.data-order-type-recent-id:first').text(), 'home');
        }

        if ($('.data-order-type-fave-id:first').text() !== "") {
          startFavoriteOrder($('.data-order-type-fave-id:first').text(), 'home');
        }

        if ($('.data-order-type-location-id:first').text() !== "") {
          startReferralOrder($('.data-order-type-location-id:first').text(), $('.data-order-type-location-sbt:first').text(), 'home');
        }
      });

      $('#home-toggle-switch-on-off').change(function () {
        if ($('input[name="home-order-schedule"]:checked').val() == 'advance') {
          $('#home-schedule-time').removeClass('hide')
        } else {
          $('#home-schedule-time').addClass('hide')
        }
      });
      $('#home-toggle-switch-on-off').trigger('change');

      $('input[name="home-order-type"]').off('change');
      $('input[name="home-order-type"]').change(function () {

        //clearLocationList();

        if ($('input[name="home-order-type"]:checked').val() !== "dispatch") {
          $('#home-order-location-search').addClass('hide');
          $('#home-order-location-search-building').addClass('hide');
          $('.fa-location-dot').addClass('hide');
          $('#home-order-location-search-building').val('');
        } else {
          $('#home-order-location-search').removeClass('hide');
          $('#home-order-location-search-building').removeClass('hide');
          $('.fa-location-dot').removeClass('hide');
        }

        if ($('#home-order-location-search').val()) {
          $('#home-order-location-search-form').submit();
        } else {
          populate_user_restaurants('home');
        }
      });

      // Actions on changing the order type
      $('input[name="start-order-order-type"]').change(function () {
        if (
          $('input[name="start-order-order-type"]:checked').val() !== "dispatch"
        ) {
          $("[data-search-pickup]").removeClass("hide");
          $("[data-search-deliver]").addClass("hide");
          $("#start-order-order-location-search-building").val("");
        } else {
          $("[data-search-pickup]").addClass("hide");
          $("[data-search-deliver]").removeClass("hide");
        }
      });

      // Hide/show schedule elements
      $('input[name="start-order-order-schedule"]').change(function () {
        if (
          $('input[name="start-order-order-schedule"]:checked').val() ==
          "advance"
        ) {
          $("#start-order-schedule-time").removeClass("hide");
        } else {
          $("#start-order-schedule-time").addClass("hide");
        }
        // console.log($('input[name="order-schedule"]:checked').val()); 
      });

      // Get Schedule dates
      var todaysDate = new Date();
      var tomorrowsDate = new Date().addDays(1);
      var scheduleDates = getDates(todaysDate, new Date().addDays(45));
      var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      for (var i = 0; i < scheduleDates.length; i++) {
        var dayValue =
          scheduleDates[i].getFullYear() +
          "-" +
          zeroPad(scheduleDates[i].getMonth() + 1, 2) +
          "-" +
          zeroPad(scheduleDates[i].getDate(), 2);
        var dayLabel =
          daysOfWeek[scheduleDates[i].getDay()] +
          " " +
          (scheduleDates[i].getMonth() + 1) +
          "/" +
          scheduleDates[i].getDate();

        if (scheduleDates[i].getTime() === todaysDate.getTime()) {
          dayLabel = "Today";
        }
        if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
          dayLabel = "Tomorrow";
        }

        $("[data-order-start-order-time-wanted-day]").append(
          '<option value="' + dayValue + '">' + dayLabel + "</option>"
        );

        $("[data-home-order-time-wanted-day]").append(
          '<option value="' + dayValue + '">' + dayLabel + "</option>"
        );
      }

      // Set time selections
      var timeSelection = createQuarterHourIntervals();
      for (var ii = 0; ii < timeSelection.length; ii++) {
        $("[data-order-start-order-time-wanted-time]").append(
          '<option value="' +
          convert12to24Hour(timeSelection[ii]) +
          '">' +
          timeSelection[ii] +
          "</option>"
        );

        $("[data-home-order-time-wanted-time]").append(
          '<option value="' +
          convert12to24Hour(timeSelection[ii]) +
          '">' +
          timeSelection[ii] +
          "</option>"
        );
      }

      // actions for changing the time wanted (day)
      $("select#start-order-time-wanted-day").change(function () {
        if (
          $(
            'select#start-order-time-wanted-day option[value="' +
            $(this).val() +
            '"]'
          ).text() == "Today"
        ) {
          var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
          // console.log(currentTime);
          $("select#start-order-time-wanted-time-slot option").each(
            function () {
              if ($(this).val() < currentTime) {
                $(this).addClass("hide");
              }
              $("select#start-order-time-wanted-time-slot").val(currentTime);
            }
          );
        } else {
          $("select#start-order-time-wanted-time-slot option").each(
            function () {
              $(this).removeClass("hide");
            }
          );
        }
      });
      $("select#start-order-time-wanted-day").trigger("change");

      $("#home-time-wanted-day").change(function () {
        if (
          $(
            '#home-time-wanted-day option[value="' +
            $(this).val() +
            '"]'
          ).text() == "Today"
        ) {
          var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
          // console.log(currentTime);
          $("#home-time-wanted-time-slot option").each(
            function () {
              if ($(this).val() < currentTime) {
                $(this).addClass("hide");
              }
              $("#home-time-wanted-time-slot").val(currentTime);
            }
          );
        } else {
          $("#home-time-wanted-time-slot option").each(
            function () {
              $(this).removeClass("hide");
            }
          );
        }
      });
      $("#home-time-wanted-day").trigger("change");

      // Autocomplete for location search
      if ($("#start-order-order-location-search").length) {
        const inputD = $("#start-order-order-location-search")[0];
        const options = {
          // componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry"],
          strictBounds: false,
          // types: ['(regions)'],
        };

        const autocompleteD = new google.maps.places.Autocomplete(
          inputD,
          options
        );
        autocompleteD.addListener("place_changed", function () {
          const place = autocompleteD.getPlace();
          if (place.geometry) {
            // ttmap.systemZoomChange = true;
            // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
            olo_get_nearby_locations(
              place.geometry.location.lat(),
              place.geometry.location.lng(),
              "",
              "start-order"
            );
            // console.log(place);

            var components = {};
            $.each(place.address_components, function (k, v1) {
              $.each(v1.types, function (k2, v2) {
                components[v2] = v1.long_name;
              });
            });

            // console.log($('#order-location-search-streetaddress').val());
            // console.log($('#order-location-search-city').val());
            // console.log($('#order-location-search-zipcode').val());
          }
        });

        $("#start-order-order-location-search-form").submit(function (e) {
          e.preventDefault();

          // console.log("search locations");

          $("#start-order-order-location-search").blur();

          var address = $("#start-order-order-location-search").val();
          var geocoder = new google.maps.Geocoder();

          if (address.length) {
            geocoder.geocode(
              {
                address: address,
              },
              function (results, status) {
                // console.log("GEOCODER STATUS ", status, results);
                if (status == google.maps.GeocoderStatus.OK) {
                  // console.log(results);

                  var components = {};
                  $.each(results[0].address_components, function (k, v1) {
                    $.each(v1.types, function (k2, v2) {
                      components[v2] = v1.long_name;
                    });
                  });

                  // console.log('address components', components);

                  if (components.street_number && components.route) {
                    $("#start-order-order-location-search-streetaddress").val(
                      components.street_number + " " + components.route
                    );
                  }

                  if ('locality' in components) {
                    $('#start-order-order-location-search-city').val(components.locality);
                  } else if ('administrative_area_level_2' in components) {
                    $('#start-order-order-location-search-city').val(components.administrative_area_level_2);
                  }

                  $("#start-order-order-location-search-zipcode").val(
                    components.postal_code
                  );

                  olo_get_nearby_locations(
                    results[0].geometry.location.lat(),
                    results[0].geometry.location.lng(),
                    "",
                    "start-order"
                  );
                } else {
                  $("#start-order-order-location-search").val("");
                  charleys_hide_loading();
                }
              }
            );
          } else {
            charleys_hide_loading();
          }
        });

        // initMap();
      }

      // Autocomplete for location search
      if ($("#home-order-location-search").length) {
        const inputD = $("#home-order-location-search")[0];
        const options = {
          // componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry"],
          strictBounds: false,
          // types: ['(regions)'],
        };

        const autocompleteD = new google.maps.places.Autocomplete(
          inputD,
          options
        );
        autocompleteD.addListener("place_changed", function () {
          const place = autocompleteD.getPlace();
          if (place.geometry) {
            // ttmap.systemZoomChange = true;
            // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
            /*olo_get_nearby_locations(
                place.geometry.location.lat(),
                place.geometry.location.lng(),
                "",
                "home"
            );*/
            // console.log(place);

            var components = {};
            $.each(place.address_components, function (k, v1) {
              $.each(v1.types, function (k2, v2) {
                components[v2] = v1.long_name;
              });
            });

            if (components.street_number && components.route) {
              $("#home-order-location-search-streetaddress").val(
                components.street_number + " " + components.route
              );
            }

            if ("locality" in components) {
              $("#home-order-location-search-city").val(components.locality);
            } else if ("administrative_area_level_2" in components) {
              $("#home-order-location-search-city").val(
                components.administrative_area_level_2
              );
            }

            $("#home-order-location-search-zipcode").val(
              components.postal_code
            );

            // console.log($('#order-location-search-streetaddress').val());
            // console.log($('#order-location-search-city').val());
            // console.log($('#order-location-search-zipcode').val());
          }
        });

        $("#home-order-location-search-form").submit(function (e) {
          e.preventDefault();

          // console.log("search locations");

          $("#home-order-location-search").blur();

          var address = $("#home-order-location-search").val();
          var geocoder = new google.maps.Geocoder();

          if (address.length) {
            geocoder.geocode(
              {
                address: address,
              },
              function (results, status) {
                // console.log("GEOCODER STATUS ", status, results);
                if (status == google.maps.GeocoderStatus.OK) {
                  // console.log(results);

                  var components = {};
                  $.each(results[0].address_components, function (k, v1) {
                    $.each(v1.types, function (k2, v2) {
                      components[v2] = v1.long_name;
                    });
                  });

                  // console.log('address components', components);

                  if (components.street_number && components.route) {
                    $("#home-order-location-search-streetaddress").val(
                      components.street_number + " " + components.route
                    );

                    $("#start-order-order-location-search-streetaddress").val(
                      components.street_number + " " + components.route
                    );
                  }

                  if ('locality' in components) {
                    $('#home-order-location-search-city').val(components.locality);
                  } else if ('administrative_area_level_2' in components) {
                    $('#home-order-location-search-city').val(components.administrative_area_level_2);
                  }

                  $("#home-order-location-search-zipcode").val(
                    components.postal_code
                  );

                  /*olo_get_nearby_locations(
                      results[0].geometry.location.lat(),
                      results[0].geometry.location.lng(),
                      "",
                      "start-order"
                  );*/
                } else {
                  $("#home-order-location-search").val("");
                  charleys_hide_loading();
                }
              }
            );
          } else {
            charleys_hide_loading();
          }
        });

        // initMap();
      }

      // Autocomplete for location search
      if ($("#start-order-order-location-search-delivery").length) {
        const inputD = $("#start-order-order-location-search-delivery")[0];
        const options = {
          // componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry"],
          strictBounds: false,
          // types: ['(regions)'],
        };

        const autocompleteD = new google.maps.places.Autocomplete(
          inputD,
          options
        );
        autocompleteD.addListener("place_changed", function () {
          const place = autocompleteD.getPlace();
          if (place.geometry) {
            // ttmap.systemZoomChange = true;
            // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);

            charleys_show_loading();

            var nearbyData = {
              action: "get_nearby_locations",
              lat: place.geometry.location.lat(),
              long: place.geometry.location.lng(),
              distance: "",
            };

            $.ajax({
              type: "POST",
              url: ajax_url,
              data: nearbyData,
              success: function (response) {
                // console.log(response);
                var result = JSON.parse(response);
                if (result.status == "success" && result.data !== null) {
                  // console.log(result.data.restaurants);
                  //var isDelivery = false;
                  // if($('[name="order-type"]:checked').val() == 'dispatch') {
                  //if($('input[name="' + view_context + '-order-type"]:checked').val() == 'dispatch') {
                  //  isDelivery = true;
                  //}

                  let is_in_dispatch_range = false;
                  let location_item_vendor_id = $(
                    "#start-order-order-location-search-delivery"
                  )
                    .closest(".location-item")
                    .attr("data-location-id");
                  result.data.restaurants.forEach(function (restaurant) {
                    if (restaurant.id == location_item_vendor_id) {
                      is_in_dispatch_range = true;
                    }
                  });

                  if (is_in_dispatch_range) {
                    var components = {};
                    $.each(place.address_components, function (k, v1) {
                      $.each(v1.types, function (k2, v2) {
                        components[v2] = v1.long_name;
                      });
                    });

                    if (components.street_number && components.route) {
                      $("#start-order-order-location-search-streetaddress").val(
                        components.street_number + " " + components.route
                      );
                    }

                    if ('locality' in components) {
                      $('#start-order-order-location-search-city').val(components.locality);
                    } else if ('administrative_area_level_2' in components) {
                      $('#start-order-order-location-search-city').val(components.administrative_area_level_2);
                    }

                    $("#start-order-order-location-search-zipcode").val(
                      components.postal_code
                    );

                    $(
                      "#start-order-order-location-search-delivery"
                    ).removeClass("form-alert");
                    $("[data-delivery-error]").text("");
                    $(
                      "#start-order-order-location-search-error-delivery"
                    ).addClass("hide");
                  } else {
                    $("#start-order-order-location-search-delivery").addClass(
                      "form-alert"
                    );
                    $("[data-delivery-error]").text(
                      "This address is not within this restaurant's delivery range."
                    );
                    $(
                      "#start-order-order-location-search-error-delivery"
                    ).removeClass("hide");
                  }

                  charleys_hide_loading();
                } else {
                  $("#start-order-order-location-search-delivery").addClass(
                    "form-alert"
                  );
                  $("[data-delivery-error]").text(
                    "This address is not within this restaurant's delivery range."
                  );
                  $(
                    "#start-order-order-location-search-error-delivery"
                  ).removeClass("hide");

                  charleys_hide_loading();
                }
              },
              complete: function () {
                charleys_hide_loading();
              },
            });
            // console.log(place);
          }
        });
      }

      if ($("#start-order-order-location-search").length) {
        const inputD = $("#start-order-order-location-search")[0];
        const options = {
          // componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry"],
          strictBounds: false,
          // types: ['(regions)'],
        };

        const autocompleteD = new google.maps.places.Autocomplete(
          inputD,
          options
        );
        autocompleteD.addListener("place_changed", function () {
          const place = autocompleteD.getPlace();
          if (place.geometry) {
            // ttmap.systemZoomChange = true;
            // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
            olo_get_nearby_locations(
              place.geometry.location.lat(),
              place.geometry.location.lng(),
              "",
              "start-order"
            );
            // console.log(place);

            var components = {};
            $.each(place.address_components, function (k, v1) {
              $.each(v1.types, function (k2, v2) {
                components[v2] = v1.long_name;
              });
            });

            // console.log($('#order-location-search-streetaddress').val());
            // console.log($('#order-location-search-city').val());
            // console.log($('#order-location-search-zipcode').val());
          }
        });

        // initMap();
      }

      $("#start-order-select-order-type-button").click(function () {
        //$('#' + view_context + '-select-order-type').foundation('close');
        
        var validAddress = true;
        var isDelivery = Boolean(
          $('input[name="start-order-order-type"]:checked').val() == "dispatch"
        );
        // console.log("location id");
        // console.log($(this).closest(".location-item").attr("data-location-id"));
        var vendorid = $(this)
          .closest(".location-item") 
          .attr("data-location-id");
        var supportsbaskettransfers =
          $(this)
            .closest(".location-item")
            .attr("data-supportsbaskettransfers") == "true";

        // Delivery requires a full address, thus fails validation if no street address is present
        if (
          isDelivery &&
          !$("#start-order-order-location-search-streetaddress").val().length
        ) {
          validAddress = false;
        }

        // console.log("validAddress", validAddress);

        $("#start-order-order-location-search").removeClass("form-alert");
        $("#start-order-order-location-search-error").addClass("hide");

        if (validAddress) {


          charleys_show_loading();
          setAddressComponents("start-order");
          selectLocation(
            vendorid,
            supportsbaskettransfers,
            false,
            "start-order"
          );
        } else {
          $("#start-order-order-location-search").addClass("form-alert");
          $("#start-order-order-location-search-error").removeClass("hide");
        }
      });

      populate_user_restaurants("start-order");

      let googleStoreSlug = getCookie('charleys_google_store_slug');
      let googleHandoffMode = getCookie('charleys_google_handoff_mode');

      if (typeof googleStoreSlug !== 'undefined' && googleStoreSlug.length > 0) {
        if (googleHandoffMode == 'pickup' || googleHandoffMode == 'curbside' || googleHandoffMode == 'dispatch') {
          //$('#home-select-order-type').find('.order-type-select').val(googleHandoffMode);
          if (googleHandoffMode == 'dinein') {
            $('#home-dinein').trigger('click');
          }
          if (googleHandoffMode == 'curbside') {
            $('#home-curbside').trigger('click');
          }
          if (googleHandoffMode == 'dispatch') {
            $('#home-delivery').trigger('click');
            $('#home-order-location-search').removeClass('hide');
            $('#home-order-location-search-building').removeClass('hide');
            $('.fa-location-dot').removeClass('hide');
          }
        }

        $.ajax({
          type: 'POST',
          url: ajax_url,
          data: {
            action: 'get_olo_restaurant_by_slug',
            authtoken: localStorage.getItem('charleys_auth_token'),
            slug: googleStoreSlug
          },
          success: function (response) {
            var results = JSON.parse(response);

            if (results.id) {
              setAsStore(results.id);

              // console.log('klug dinein');
              // console.log(results.supportsdinein);
              if (results.supportsdinein != true) {
                $("label[for='home-dinein']").hide();
              }
              if (results.supportsdispatch != true) {
                $("label[for='home-dispatch']").hide();
              }
              if (results.supportscurbside != true) {
                $("label[for='home-curbside']").hide();
              }
              $('#home-select-order-type').find('.data-order-type-location-id').text(results.id);
              $('#home-select-order-type').find('.data-order-type-location-sbt').text(results.supportsbaskettransfers);
              $('#home-select-order-type').foundation('open');
            }
          }
        });
      }
    })
    .hide()
    .fadeIn(transitionDuration);
}


function fitToMarkerBounds_order(ttmapObj) {
  // console.log("fitToMarkerBounds");

  if (order_markers.length) {
    var bbox = [
      [0, 0],
      [0, 0],
    ];
    var lats = [];
    var lngs = [];

    for (var i = 0; i < order_markers.length; i++) {
      var lnglat = order_markers[i].getLngLat();
      lats.push(lnglat.lng);
      lngs.push(lnglat.lat);
    }

    var minlat = Math.min.apply(null, lats),
      maxlat = Math.max.apply(null, lats);
    var minlng = Math.min.apply(null, lngs),
      maxlng = Math.max.apply(null, lngs);

    bbox = [
      [minlat, minlng],
      [maxlat, maxlng],
    ];

    ttmapObj.fitBounds(bbox, {
      padding: { top: 75, bottom: 75, left: 75, right: 75 },
      maxZoom: 12,
    });
  }
} // end fitToMarkerBounds
